import { h } from 'preact';

const VariantSelector = ({
  availabilityMatrix,
  option,
  selectedOptions,
  setSelectedOptions,
  variants
}) => {

  const optionId = `product-option-${option.name}`;
  const selectedOptionValue =
    selectedOptions.find(o => o.name === option.name)?.value;
  const showOutOfStock = !availabilityMatrix[option.name][selectedOptionValue];

  const isOptionInVariant = (selectedOption, variantOptions) =>
  variantOptions.some(op => 
    op.name === selectedOption.name && op.value === selectedOption.value);


  const handleVariantChange = (e) => {
    const updatedOption = e.target.dataset.optionName;
    const newlySelectedOptions = selectedOptions.map((o) =>
    o.name === updatedOption
      ? { name: updatedOption, value: e.target.value }
      : o
    );

    const newVariant = variants.find(
      (v) =>
        JSON.stringify(v.selectedOptions) === 
        JSON.stringify(newlySelectedOptions),
    );

    if(!newVariant){
      let newAvailableSelectedOptions = 
      [
        { name: updatedOption, 
          value: e.target.value
        }
      ]

      if(newAvailableSelectedOptions.length < 3){
        for (let j = 0; j < variants.length; j += 1){
          const containsAllSelectedOptions = newAvailableSelectedOptions
          .every(selectedOption => 
            isOptionInVariant(selectedOption, variants[j].selectedOptions));

          if(containsAllSelectedOptions){
            newAvailableSelectedOptions = variants[j].selectedOptions 
            break
          }
        }
      }
      setSelectedOptions(newAvailableSelectedOptions);
    } else {
      setSelectedOptions(so => so.map((o) =>
        o.name === updatedOption
          ? { name: updatedOption, value: e.target.value }
          : o
      ));
    }
  };

  // eslint-disable-next-line consistent-return
  const assignColors = (index) => {
    if(option.name === 'Color'){
      return `var(--swatch-${handleize(option.values[index])}, #CCC)`;
    }
  }

  const handleize = (inputString) =>
     inputString.toLowerCase()
      .trim()
      /* eslint-disable no-useless-escape */
      .replace(/\s+/g, '-')
      .replace(/[^\w\-]+/g, '')
      .replace(/\-\-+/g, '-')
    /* eslint-enable no-useless-escape */

  return (
    <div className={option.name === 'Color' ? "atc-sticky:m-0 mt-6 md:mt-8 mb-8" : "atc-sticky:hidden atc-sticky:m-0 mt-6 md:mt-8 mb-8"}>
      <div className="flex utility-2">
        <span className='atc-sticky:hidden'>{option.name}</span>
        <span className="atc-sticky:m-0 ml-2 font-bold">
          {selectedOptionValue}
        </span>
        {showOutOfStock && <span className="atc-sticky:hidden ml-2 text-red">
          {window.TMW.Strings.product.outOfStock}
        </span>}
      </div>
      <div className="atc-sticky:hidden flex flex-wrap items-center gap-4 md:gap-2 mt-2">
        {option.values.map((value, index) =>  (
          <div
            className={option.name === 'Color' ? "color-swatch" : "variant-btn"}
            key={`${optionId}-${value}`}
          >
            <input
              id={`${optionId}_${index}`}
              value={value}
              data-option-name={option.name}
              type="radio"
              name={option.name}
              checked={selectedOptionValue === value}
              onChange={handleVariantChange}
            />
            <label
              htmlFor={`${optionId}_${index}`}
              key={`${optionId}-${value}`}
              style={{ backgroundColor: assignColors(index) }}
              className={availabilityMatrix[option.name][value] ? '' : 'unavailable'}
            >
              {option.name !== 'Color' && value}
            </label>
          </div>
        ))}
      </div>
    </div>
  );  
};

export default VariantSelector;
